// Vuex
import Request from './request';

// 门店优惠券一览
async function getShopCoupons(data) {
    return Request('get', "api/coupons/get-shop-coupons", data);
}

// 获取可领取优惠券一览
async function couponsList() {
    return Request('get', "api/coupons/coupons-list");
}

// 领取单个优惠券
async function receive(data) {
    return Request('post', "api/coupons/receive", data);
}

// 领取全部优惠券
async function receiveAll() {
    return Request('post', "api/coupons/receive-all");
}


export default {
    getShopCoupons,
    couponsList,
    receive,
    receiveAll,
}
